var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"formulario"},[_c('div',{staticClass:"titulo"},[_c('h2',[_vm._v(_vm._s(_vm.titulo))])]),_vm._v(" "),_c('div',{staticClass:"dadosHistorico"},[_c('b-alert',{staticClass:"negrito",attrs:{"show":""}},[_vm._v(_vm._s(_vm.mensagemServidor))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2835564a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ConfirmaRequerimento.vue
// module id = 343
// module chunks = 0